import * as React from 'react'

const styling: React.CSSProperties = {
    position: 'absolute',
    border: '1px solid transparent',
    top: '4px',
    right: '0',
    fontSize: '35px',
    cursor: 'pointer',
    width: '25px',
    height: '25px',
    textAlign: 'center',
    color: 'darkgray',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    zIndex: 98,
}

type Props = {
    closeAction: () => void,
    top?: string;
    right?: string;
    zIndex?:number;
    position?:string;
    float?:string;
}

 export class CloseX extends React.Component<Props, any>{
    render() {
        var offset = {
            top: this.props.top || styling.top,
            right: this.props.right || styling.right,
            zIndex:this.props.zIndex || styling.zIndex,
            position: this.props.position || styling.position,
            float: this.props.float || styling.float
        }
        var finalStyling = Object.assign({}, styling, offset);

        return (
            <div style={finalStyling} onClick={this.props.closeAction}>&times;</div>
        );
    }
}

